@if (isOpen) {
  <div>
    <div>
      <div class="coords-header d-flex flex-row justify-content-between">
        <h4 class="mx-2">Navigera via koordinat</h4>
        <rask-icon-button class="mx-2 close-btn" color="tertiary" icon="fas fa-times" (click)="close()"></rask-icon-button>
      </div>
      <div class="d-flex flex-row justify-content-around">
        @if (coordsCanPaste()) {
          <rask-button class="coords-btn" color="tertiary" icon="fas fa-paste" (click)="pasteCoordinates()">Klistra in från urklipp</rask-button>
        }
      </div>
      <div class="d-flex flex-row justify-content-around">
        <rask-input [disabled]="false" class="coords-menu-input my-1" placeholder="Sweref E" [(ngModel)]="data.navigateToX" (change)="inputChanged($event)"></rask-input>
        <rask-input [disabled]="false" class="coords-menu-input my-1" placeholder="Sweref N" [(ngModel)]="data.navigateToY" (change)="inputChanged($event)"></rask-input>
      </div>
      <div class="d-flex flex-column">
        <rask-button class="coords-btn" [disabled]="!data.canNavigate()" icon="fa-solid fa-hand-point-right"  (click)="coordsClickNavigate()">Navigera till koordinat</rask-button>
        @if (coordsCanCopy()) {
          <rask-button class="coords-btn" [disabled]="copying" color="tertiary" icon="far fa-copy" (click)="copyCurrentCoordinates()">Kopiera nuvarande position</rask-button>
        }
      </div>
    </div>
  </div>
}
